import { render, staticRenderFns } from "./InfoUserCard.vue?vue&type=template&id=0e990507&scoped=true"
import script from "./InfoUserCard.vue?vue&type=script&lang=ts"
export * from "./InfoUserCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e990507",
  null
  
)

export default component.exports